export default __webpack_public_path__ + "static/media/sypialnie1.5a8d266f.jpg";